export default __webpack_public_path__ + "static/cp-buffer-3e970f7a4939bd567506ff355a02c972.mp4";